import React from 'react';
import T from 'prop-types';
import {
  Heading,
  Button,
  IconStatusInformationOnlight,
  PlaybackList,
  PlaybackKey,
  Link,
  Paragraph,
  HorizontalRule,
} from '@piggybank/core';
import {
  Translation,
  TranslationScope,
  Optional,
} from 'srcAlias/client/locale';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import { useSelector } from 'react-redux';
import { selectQueryParams } from 'srcAlias/client/state/selectors';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';
import config from 'configAlias';
export const Ineligible = ({ segmentName, pageName }) => {
  useTrackPageViewAnalytics('ineligible');
  const queryParams = useSelector(selectQueryParams);
  return (
    <TranslationScope path={`${segmentName}.${pageName}`}>
      <span style={{ color: 'var(--sapphire)' }}>
        <IconStatusInformationOnlight width="3em" />
      </span>
      <Heading level={1}>
        <Translation path="heading" />
      </Heading>
      <HorizontalRule marginBottom={4} />
      <Paragraph>
        <Translation path="ineligibleText" />
      </Paragraph>
      <Heading accentBar level={2}>
        <Translation path="whatCanIDo" />
      </Heading>
      <Paragraph>
        <Translation path="whatCanIDoText" />
        <Link
          href="https://www.hsbc.com.sg/wealth/investments/"
          external
          textMap={{
            newWindow: <Translation path="linkText" />,
          }}
          name="visitWebsiteIneligiblePageLink"
        >
          <Translation path="linkText" />
        </Link>
      </Paragraph>
      <Heading level={3}>
        <Translation path="talkToUs" />
      </Heading>
      <Paragraph>
        <Translation path="talkToUsText" />
      </Paragraph>
      <PlaybackList type="review">
        <PlaybackKey>
          <Translation path="hsbcJade" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="hsbcJadeValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursMalaysia" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>

        <PlaybackKey>
          <Translation path="premier" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="premierValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursPremier" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>

        <PlaybackKey>
          <Translation path="hsbcPersonalBanking" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="hsbcPersonalBankingValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursAmanah" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>
        <Optional>
          <Paragraph>
            <Translation path="alternativelyTxt" />
            <Link
              external
              href="https://www.hsbc.com.sg/contact/"
              textMap={{ newWindow: <Translation path="textMap" /> }}
              name="requestCallbackIneligiblePageLink"
            >
              <Translation path="requestLinkTxt" />
            </Link>
          </Paragraph>
        </Optional>
      </PlaybackList>
      {(queryParams === null ||
        queryParams.source === null ||
        queryParams.source !== 'mobilex') && (
        <Optional>
          <Button
            onClick={() => clickContinue(pageName, __GOTOMYACCOUNT_URL__)}
            elementType="a"
            secondary={config.isSecondaryButton}
            target="_self"
            href={__GOTOMYACCOUNT_URL__}
          >
            <Translation path="goToMyAccount" />
          </Button>
        </Optional>
      )}
    </TranslationScope>
  );
};

Ineligible.propTypes = {
  segmentName: T.string,
  pageName: T.string,
};
